export enum TipoCorrida {
    IDA = 0,
    IDAVOLTA = 1,
    AGENDADA = 2
}